import React from "react";
import PropTypes from "prop-types";
import R from "ramda";
import { addressType } from "custom-prop-types";
import { DocReturn } from "components/settings/doc-return";
import { MailInSettingsForm } from "components/settings/mail-in-settings-form";

export const MailInSettings = ({
  accountId,
  address,
  docReturn,
  isDocumentReturnLoading,
  onDisableDocReturn,
  onEnableDocReturn,
  onSaveAddress,
  vip
}) => {
  const initialValues = R.clone(address);
  initialValues.country = { key: address.country, name: address.country };
  return (
    <div>
      <h1>Mail-in Settings</h1>
      <DocReturn
        accountId={ accountId }
        docReturn={ docReturn }
        isDocumentReturnLoading={ isDocumentReturnLoading }
        onDisableDocReturn={ onDisableDocReturn }
        onEnableDocReturn={ onEnableDocReturn }
        vip={ vip }
      />
      <MailInSettingsForm initialValues={ initialValues } onSaveAddress={ onSaveAddress } />
    </div>
  );
};


MailInSettings.propTypes = {
  accountId: PropTypes.string.isRequired,
  address: addressType.isRequired,
  docReturn: PropTypes.bool.isRequired,
  isDocumentReturnLoading: PropTypes.bool.isRequired,
  onDisableDocReturn: PropTypes.func.isRequired,
  onEnableDocReturn: PropTypes.func.isRequired,
  onSaveAddress: PropTypes.func.isRequired,
  vip: PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/settings/mail-in-settings.jsx